import { get, isEmpty } from 'lodash';
import { logout } from '../actions';

export default store => next => action => {
  if (get(action, 'payload.name') === 'ApiError') {
    switch (action.payload.status) {
      case 401:
      case 404: {
        const errors = get(action.payload, 'response.errors', {});
        store.dispatch(logout({ errors: isEmpty(errors) ? { 'api': get(action.payload, 'response.error', action.payload.message) } : errors }));
        break;
      }
      default:
        return next(action);
    }
  } else {
    return next(action);
  }
}
